import React from 'react';
import PropTypes from 'prop-types';
import TimeInput from './TimeInput';
import FloatInput from './FloatInput';

class NumberOrTimeInput extends React.Component {
  render() {
    const { isTimeFormat, ...otherProps } = this.props;

    return (
      isTimeFormat ? <TimeInput {...otherProps} /> : <FloatInput {...otherProps} />
    );
  }
}

NumberOrTimeInput.propTypes = {
  isTimeFormat: PropTypes.bool.isRequired,
};

NumberOrTimeInput.defaultProps = {
  isTimeFormat: false,
};

export default NumberOrTimeInput;
